import { MediaLinkModel } from "./medialink.model";
import { API_URL } from "../../crossconcern/utilities/properties/base.property";

export class MediaModel {

    public uuid: string;
    public entityUUID: string;
    public customTag: string;
    public links: MediaLinkModel[];

    constructor(value: JSON) {
        this.uuid = value["uuid"];
        this.entityUUID = value["entity_uuid"];
        this.customTag = value["custom_tag"];
        if(value["links"]) {
            this.links = [];
            for(const link of value["links"]) {
                this.links.push(new MediaLinkModel(link));
            }
        }
    }

    public getMediaURL(rel: string): string {
        if(this.links) {
            for(const link of this.links) {
                if(link.rel === rel) {
                    if (link.href.includes("http://localhost:8080/virtualtour/")) {
                        return link.href.replace("http://localhost:8080/virtualtour/", API_URL);
                    }
                    return link.href;
                }
            }
        }
        return null;
    }
}